export default {
    rotaVolta: {
        name: 'ComprasDiretasLegadas',
        params: {},
        query: {}
    },
    documentoDesentranhamento:{},
    execucaoAtiva: {},
    compraDireta: {
        acompanhamento: {},
        analiseDocumentos: {
            documentosAnalizaveis: [],
            documentosNaoAnalizaveis: [],
            situacao: null,
            situacaoCompra: null,
            situacaoItemLote: null,
            situacaoFornecedor: null,
            ehCompraDiretaVirtualizada: false
        },
        convidados: [],
        documentosSolicitados: [],
        linhasFornecimento: [],
        anexos: [],
        lotes: [],
        itens: [],
        situacao: null,
        dataHoraInicioEnvioPropostas: null,
        dataHoraFimEnvioPropostas: null,
        dataHoraInicioEnvioLances: null
    },
    compraDiretaSuspensa: false,
    comprador: {
        paginacao: {
            page: 1,
            rowsPerPage: 10,
            descending: true,
            sortBy: 'id'
        },
        resultadoBuscaAvancadaComprasDiretas: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: [],
                processo: undefined,
                orgao: undefined,
                objeto: undefined,
                operador: undefined
            },
            async reset(){
                this.filtros.situacoes = []
                this.filtros.processo = undefined
                this.filtros.orgao = undefined
                this.filtros.objeto = undefined
                this.filtros.operador = undefined
            }
        },
        resultadoBuscaTodasComprasDiretas: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: ['EM_ELABORACAO', 'AGUARDANDO_ABERTURA', 'ABERTA', 'EM_ANALISE', 'REANALISE', 'ENCERRADA', 'PROCESSANDO', 'SUSPENSA'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        },
        resultadoBuscaComprasDiretasEmAndamento: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: ['AGUARDANDO_ABERTURA', 'ABERTA', 'EM_ANALISE', 'REANALISE', 'SUSPENSA'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: '',
                    label: 'Pesquisa'
                }
            }
        },
        resultadoBuscaComprasLegadas: {
            filtros: {
                conteudo: '',
                objeto: {
                    value: null,
                    default: '',
                    label: 'Pesquisa'
                }
            },
            paginacao: {
                page: 1,
                rowsPerPage: 10
            }
        },
        resultadoBuscaComprasDiretasEmElaboracao: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: ['EM_ELABORACAO'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        },
        resultadoBuscaComprasDiretasEncerradas: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: 'ENCERRADA',
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        },
        resultadoCompraDireta: {},
        resultadoItensELotes: [],
        filaRequisicoes:{
            paginacao:{
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'id'
            },
            filtros: {
                situacoes: ['PENDENTE', 'ERRO', 'CONCLUIDO', 'PROCESSADO', 'CANCELADO'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        },
        filaRequisicoesComErro:{
            paginacao:{
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'id'
            },
            filtros: {
                situacoes: ['ERRO'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        }
    },
    fornecedor: {
        documentosSolicitados: [],
        meusLotesEItensVencedores: [],
        meusItensELotesVencedoresAReajustar: {
            valorFinalProposta: null,
            reajusteItens: [],
            reajusteLotes: [],
            idVirtualizado: null,
            reajusteAssinado: false,
            urlVirtualizacaoReajuste: null
        },
        possuiLoteItemVencedor: undefined,
        quantidadeCasasDecimaisCompraDireta: null,
        resultadoBuscaComprasDiretasEncerradas: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: 'ENCERRADA',
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        },
        resultadoBuscaMinhasComprasDiretas: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: ['ABERTA', 'EM_ANALISE', 'ENCERRADA', 'REANALISE', 'AGUARDANDO_ABERTURA', 'SUSPENSA'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        },
        resultadoBuscaMeuInteresseComprasDiretas: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraInicioEnvioPropostas'
            },
            filtros: {
                situacoes: ['ABERTA', 'AGUARDANDO_ABERTURA'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        },
        resultadoBuscaComprasDiretasDisponiveis: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: ['ABERTA', 'EM_ANALISE', 'REANALISE', 'AGUARDANDO_ABERTURA'],
                conteudo: '',
                objeto: {
                    value: null,
                    default: null,
                    label: 'Pesquisa'
                }
            }
        },
        resultadoBuscaAvancadaComprasDiretasFornecedor: {
            paginacao: {
                page: 1,
                rowsPerPage: 10,
                descending: true,
                sortBy: 'dataHoraEncerramento'
            },
            filtros: {
                situacoes: [],
                processo: undefined,
                orgao: undefined,
                objeto: undefined,
                operador: undefined
            },
            reset(){
                this.filtros.situacoes = []
                this.filtros.processo = undefined
                this.filtros.orgao = undefined
                this.filtros.objeto = undefined
                this.filtros.operador = undefined
            }
        },
        resultadoTodosLotesEItens: []
    },
    dadosGerais: {},
    documentos: [],
    documentosProposta: [],
    itensELotes: {
        itens: [],
        lotes: []
    },
    itensELotesDaProposta: {
        itens: [],
        lotes: [],
        origemCompraDireta:''
    },
    lancesDaCompraDireta: [],
    linhasFornecimento: [],
    parametros: {
        propriedadesCompraDiretas: {
            modoCriacao: null,
            gtagId: null,
            publicacao: {
                propostaManual: null
            }
        }
    },
    perfis: [],
    resumoCompraDireta: {
        processo: null,
        situacao: null,
        processoVirtualUrl: null,
        recursoFederal: null
    },
    resumoProposta: {
        consulta: null,
        criadoEm: null,
        dataHoraEncerramento: null,
        disputaPor: null,
        exibeValorReferencia: null,
        id: null,
        idProtocoloVirtualizado: null,
        isProtocoloAssinado: null,
        numeroProtocolo: null,
        objeto: null,
        orgao: null,
        processo: null,
        propostaEnviada: null,
        propostaId: null,
        quantidadeRepeticoes: null,
        situacao: null,
        situacaoProposta: null,
        tempoRandomico: null,
        tempoRandomicoLance: null,
        tipo: null,
        uriProtocolo: null,
        urlProtocoloVirtualizado: null
    },
    rota: {
        origem: 'Inicial'
    },
    salvamentoAutomatico: {
        salvando: false
    },
    termos: {
        totalmentePreenchido: null,
        aceiteTermo: null,
        ativa: null,
        compraDiretaId: null,
        id: null,
        origem: null,
        pessoaId: null,
        possuiPorte: null,
        prazoEntregaDescritivo: null,
        usuarioProponenteId: null,
        validadeProposta: null
    },
    linguagem: 'pt',
    loadingLocal: {
        mensagem: null,
        exibir: false
    },
    token:null,
    notificacoes:{
        mensagens: [],
        paginacao: {
            page: 1,
            rowsPerPage: 10,
            sortBy: null,
            sort: null
        },
        filtros: {
            situacoes: ['VISUALIZADA', 'NAO_VISUALIZADA']
        },
        situacoesIniciais: ['VISUALIZADA', 'NAO_VISUALIZADA'],
        fornecedor:{
            tipos: ['SOLICITACAO_READEQUACAO', 'SOLICITACAO_NEGOCIACAO', 'SOLICITACAO_REENVIO_DOCUMENTO', 'SOLICITACAO_ENVIO_DOCUMENTO', 'INICIO_LANCE_DESEMPATE'],
            tipoMensagem:['MENSAGEM_FORNECEDOR']
        },
        comprador: {
            tipos: ['ATENDIMENTO_READEQUACAO', 'ATENDIMENTO_NEGOCIACAO', 'ATENDIMENTO_REENVIO_DOCUMENTO', 'ATENDIMENTO_ENVIO_DOCUMENTO'],
            tipoMensagem:['MENSAGEM_COMPRADOR']
        }
    },
    chat: {
        paginacao: {
            page: 1,
            rowsPerPage: 10,
            totalPages: 0,
            sortBy: null,
            sort: null
        },
        filtros: {
            situacoes: ['VISUALIZADA', 'NAO_VISUALIZADA']
        },
        mensagensResumidas:[],
        msgResumidasNaoLidas: 0,
        deveAbrirChat: false,
        currentTabChat: 'tab-mensagens',
        centralMensagens:{
            totalNaoLidas: 0
        },
        conversacao: {
            mensagens: [],
            destinatario: {
                id: null,
                nome: null,
                iniciais: null,
                online: null
            },
            compra:{
                compraDiretaId: null,
                process: null,
                itemOuLoteDescricao: null,
                itemCompraDiretaId: null,
                loteCompraDiretaId: null,
                tipo: null,
            },
            paginacao: {
                page: 1,
                rowsPerPage: 15,
                totalPages: 0,
                sortBy: null,
                sort: null
            },
            origem: {
                comprador: 'MENSAGEM_ORIGEM_COMPRADOR',
                fornecedor: 'MENSAGEM_ORIGEM_FORNECEDOR'
            },
            itemOuLoteAtualDoChat:{
                ranking: []
            },
        },
        usuariosOnline: [],
        estadoConversacaoInicial: {
            mensagens: [],
            destinatario: {
                id: null,
                nome: null,
                iniciais: null,
                online: null
            },
            compra: {
                compraDiretaId: null,
                process: null,
                itemOuLoteDescricao: null,
                itemCompraDiretaId: null,
                loteCompraDiretaId: null,
                tipo: null,
            },
            paginacao: {
                page: 1,
                rowsPerPage: 15,
                totalPages: 0,
                sortBy: null,
                sort: null
            },
            origem: {
                comprador: 'MENSAGEM_ORIGEM_COMPRADOR',
                fornecedor: 'MENSAGEM_ORIGEM_FORNECEDOR'
            },
            itemOuLoteAtualDoChat: {
                ranking: []
            }
        }
    },
    websocketService: null,
}
